import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { takeRight, throttle } from 'lodash'

import { useMessages } from '../libs/store/common/messages'
import { getUnreadCount, useRefresh } from '../libs/store/lists/unread'
import { useUnreadContext } from './contexts/unread'
import { useMessageType } from './contexts'

import { MessageList } from './components/message_list'
import { useDispatch } from 'react-redux'

import clearRecentMessages from '../libs/api/clearUnreadMessages'

function Loading() {
  return <div className="loading-screen">
    <div className="spinner-border"></div>
  </div>
}

function ToggleSections({active = 'unread', onClick: handleClick}) {
  return <div className="toggle-sections">
    <div className={active == 'unread' ? 'active' : null} onClick={() => handleClick('unread')}>unread</div>
    <div className={active == 'unread' ? null : 'active'} onClick={() => handleClick('all')}>all</div>
  </div>
}

function NewMessages({showUnread}) {
  const { mergeNew, recentMessages } = useUnreadContext()
  const count = recentMessages.length

  const handleClick = useCallback(() => {
    mergeNew()
    // showUnread()
  }, [mergeNew, showUnread])

  if (count == 0)
    return null

  return <div className="new-messages" onClick={handleClick}>
    <div>
      <div>There {count == 1 ? 'has' : 'have'} been {count} new message{count == 1 ? null : 's'}!</div>
      <small>Click to refresh</small>
    </div>
  </div>
}

function ClearUnreadButton({total}) {
  const { refresh } = useUnreadContext()
  
  const handleClick = useCallback(() => {
    clearRecentMessages().then(() => refresh())
  }, [refresh])

  if (total <= 0)
    return null

  const display_total = total > 99 ? "99+" : total
  return <button className="dome-btn dome-btn-aqua-stroke" onClick={handleClick}>mark {display_total} as read</button>
}

const Drawer = React.forwardRef(({left, top, width, onClose: handleClose}, ref) => {
  const {
    messages: messageIds, 
    loading, 
    showUnread, 
    setShowUnread, 
    total, 
    page, 
    setPage,
    finishedPaging
  } = useMessageType()

  const { mergeNew, setAutoMerge } = useUnreadContext()

  const {messages, allLoaded} = useMessages(messageIds)
  const style = { left, top, width }

  const scrollToBottom = useCallback((container) => throttle(() => {
    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight + 10 >= scrollHeight) {
      setPage(page + 1)
    }
  }, 400), [page, setPage])

  useEffect(() => { mergeNew() }, [showUnread])

  const messagesParams = {
    messages,
    loading,
    page,
    finishedPaging,
    showUnread,
    scrollToBottom
  }

  const handleForceUnread = useCallback(() => {
    if (showUnread) return

    setShowUnread(true)
  }, [showUnread, setShowUnread])

  useEffect(() => setAutoMerge(!showUnread), [ showUnread ])

  return <div className="dropdown" style={style} ref={ref}>
    <div className="message-dropdown-header">
      <div className="title">message feed</div>
      {showUnread ? <div className="count"><ClearUnreadButton total={total} /></div> : null }
      <div className="space"></div>
      <ToggleSections active={showUnread ? 'unread' : 'all'} onClick={clicked => setShowUnread(clicked == 'unread')} />
      <div className="close" onClick={handleClose}>
        <i className="fa-light fa-xmark"></i>
      </div>
    </div>

    <NewMessages showUnread={handleForceUnread} />

    <MessageList {...messagesParams} />
    { loading || !allLoaded ?  <Loading /> : null}
  </div>
})

export default Drawer